import { generatePath } from 'react-router-dom';

import { processMenu } from '../utils/menu';

/**
 * Get the banking menu items.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 * }} params
 * @returns {Array}
 */
export function getBankingMenuItems({
  businessEntityUuid,
  entitlements
}) {
  const rootBankingPath = '/d/b/:businessEntityUuid';
  const hasBanking = entitlements.has('banking');

  const statementsPath = `${rootBankingPath}/statements`;
  const payeesPath = `${rootBankingPath}/payees`;
  const connectedAccountsPath = `${rootBankingPath}/connected-accounts`;

  return [
    {
      order: 10,
      title: 'Overview',
      path: generatePath(`${rootBankingPath}/dashboard`, { businessEntityUuid })
    },
    {
      order: 20,
      show: hasBanking,
      title: 'Statements',
      path: generatePath(statementsPath, { businessEntityUuid })
    },
    {
      order: 30,
      show: hasBanking,
      title: 'Payees',
      path: generatePath(payeesPath, { businessEntityUuid })
    },
    {
      order: 40,
      show: hasBanking,
      title: 'Connected Accounts',
      path: generatePath(connectedAccountsPath, { businessEntityUuid })
    },
    {
      order: 50,
      show: hasBanking,
      title: 'Check History',
      path: generatePath(`${rootBankingPath}/transactions/check`, { businessEntityUuid })
    }
  ];
}

/**
 * Get the banking menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: string
 *  order?: number,
 * }} params
 * @returns {object}
 */
export function getBankingMenu({
  businessEntityUuid,
  entitlements,
  order
}) {
  return processMenu({
    title: 'Banking',
    icon: 'temple-fill.svg',
    links: getBankingMenuItems({
      businessEntityUuid, entitlements
    }),
    order
  });
}
